import React from 'react';

export const OpenTermsModalContext = React.createContext<((url: string) => void) | null>(null);
